var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "fixed top-0 left-0 h-screen w-screen bg-slate-100 overflow-auto scrollbar-lg",
      style: { zIndex: 999 }
    },
    [
      _c("div", { staticClass: "sticky left-0 top-0", style: { zIndex: 49 } }, [
        _c(
          "div",
          {
            staticClass:
              "px-6 h-10 flex-shrink-0 flex flex-wrap lg:flex-no-wrap items-center justify-between gap-y-2 gap-x-4 bg-pure-white"
          },
          [_c("BlBreadcrumbs", { attrs: { breadcrumbs: _vm.breadcrumbs } })],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "h-14 px-6 flex items-center justify-between bg-pure-white border-b border-slate-400"
          },
          [
            _c(
              "div",
              { staticClass: "flex items-center gap-4" },
              [
                _c("BlTextTitle4", {
                  attrs: { text: "Reschedule appointment" }
                }),
                _vm._v(" "),
                _vm.appointment
                  ? _c("div", { staticClass: "flex items-center gap-4" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "max-w-80 h-7 px-1 flex items-center gap-1 rounded bg-tulip-100",
                          attrs: { title: _vm.appointment.client.name }
                        },
                        [
                          _c("BlIcon", {
                            staticClass: "h-6 w-6",
                            attrs: { icon: "user-square", color: "tulip-7" }
                          }),
                          _vm._v(" "),
                          _c("BlTextSubtitle3", {
                            staticClass: "text-tulip-700 truncate",
                            attrs: { text: _vm.appointment.client.name }
                          })
                        ],
                        1
                      )
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("BlInputButton", {
              attrs: { type: "plain", icon: "close" },
              on: {
                clicked: function($event) {
                  return _vm.$emit("close-modal")
                }
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.modalLoading
        ? _c(
            "div",
            {
              staticClass: "w-full grid place-items-center",
              style: { minHeight: "calc(100vh - 6rem - 5rem)" }
            },
            [_c("div", { staticClass: "blum-loader" })]
          )
        : _vm.process !== "select_reschedule"
        ? _c(
            "div",
            {
              staticClass: "w-full py-8 flex flex-col items-center gap-4",
              style: { minHeight: "calc(100vh - 6rem - 5rem)" }
            },
            [
              _c("div", { staticClass: "w-152 px-10 flex flex-col" }, [
                _c(
                  "div",
                  { staticClass: "mb-1" },
                  [
                    _vm.isOrphanAppointment
                      ? _c("BlTextSubtitle1", {
                          attrs: { text: "Orphan appointment details" }
                        })
                      : _c("BlTextSubtitle1", {
                          attrs: { text: "Reschedule appointment" }
                        })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "mb-3" }, [
                  _vm.isOrphanAppointment
                    ? _c(
                        "div",
                        [
                          _c("BlTextBody2", {
                            attrs: { text: "This appointment for" }
                          }),
                          _vm._v(" "),
                          _c("BlTextBody2", {
                            staticClass: "font-bold",
                            attrs: { text: _vm.appointment.client.name }
                          }),
                          _vm._v(" "),
                          _c("BlTextBody2", {
                            attrs: {
                              text: "no longer has a therapist assigned."
                            }
                          })
                        ],
                        1
                      )
                    : _c(
                        "div",
                        [
                          _c("BlTextBody2", {
                            attrs: {
                              text:
                                "You're about to reschedule the appointment for"
                            }
                          }),
                          _vm._v(" "),
                          _c("BlTextBody2", {
                            staticClass: "font-bold",
                            attrs: { text: _vm.appointment.client.name + "." }
                          })
                        ],
                        1
                      )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex items-center gap-2" }, [
                  _c(
                    "div",
                    { staticClass: "w-25 flex-shrink-0 rounded shadow-md" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "h-7 flex items-center justify-center rounded-t bg-tomato-200"
                        },
                        [
                          _c("BlTextBody2", {
                            staticClass: "text-tomato-700",
                            attrs: { text: "Previous" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "h-18 flex flex-col items-center justify-center rounded-b bg-pure-white"
                        },
                        [
                          _c("BlTextTitle4", {
                            staticClass: "text-tomato-700",
                            attrs: {
                              text: _vm.displayDate({
                                date: _vm.appointment.date,
                                format: "DD"
                              })
                            }
                          }),
                          _vm._v(" "),
                          _c("BlTextBody2", {
                            staticClass: "text-tomato-600",
                            attrs: {
                              text: _vm.displayDate({
                                date: _vm.appointment.date,
                                format: "MMMM"
                              })
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "w-90 flex flex-col gap-1 px-2" }, [
                    _c(
                      "div",
                      { staticClass: "flex items-center gap-2" },
                      [
                        _c("BlIcon", {
                          staticClass: "h-4 w-4",
                          attrs: { icon: "user", color: "slate-6" }
                        }),
                        _vm._v(" "),
                        _vm.isOrphanAppointment
                          ? _c("BlTextBody2", {
                              staticClass: "truncate line-through",
                              attrs: { text: "No therapist assigned" }
                            })
                          : _c("BlTextBody2", {
                              staticClass: "truncate",
                              attrs: { text: _vm.userAppointment.name }
                            })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex items-center gap-2" },
                      [
                        _c("BlIcon", {
                          staticClass: "h-4 w-4",
                          attrs: { icon: "clock-outline", color: "slate-6" }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          attrs: {
                            text:
                              _vm.appointment.start_time_string +
                              " - " +
                              _vm.appointment.end_time_string
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.enableBranch
                      ? _c(
                          "div",
                          { staticClass: "flex items-center gap-2" },
                          [
                            _c("BlIcon", {
                              staticClass: "h-4 w-4",
                              attrs: { icon: "location", color: "slate-6" }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              attrs: {
                                text: _vm.appointment.room.branch
                                  ? _vm.appointment.room.branch.name
                                  : "No branch"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex items-center gap-2" },
                      [
                        _c("BlIcon", {
                          staticClass: "h-4 w-4",
                          attrs: { icon: "door", color: "slate-6" }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          attrs: { text: _vm.appointment.room.name }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex items-center gap-2" },
                      [
                        _c("BlIcon", {
                          staticClass: "h-4 w-4",
                          attrs: { icon: "piggy", color: "slate-6" }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c("BlTextBody2", {
                              attrs: {
                                text: _vm.currentSlotCount + " credit(s)"
                              }
                            }),
                            _vm._v(" "),
                            _vm.appointment.credit_transaction_services.length
                              ? _c("BlTextBody2", {
                                  attrs: {
                                    text:
                                      "of " +
                                      _vm.appointment
                                        .credit_transaction_services[0]
                                        .package_item_name
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm.isOrphanAppointment
                ? _c(
                    "div",
                    {
                      staticClass:
                        "w-152 py-10 px-10 flex flex-col bg-pure-white rounded-3xl border border-slate-400"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "mb-3 flex flex-col gap-1" },
                        [
                          _vm.isRescheduleAsReassign
                            ? _c("BlTextSubtitle1", {
                                attrs: { text: "Reassign to a new therapist" }
                              })
                            : _c("BlTextSubtitle1", {
                                attrs: { text: "Reschedule to a new timeslot" }
                              }),
                          _vm._v(" "),
                          _vm.isRescheduleAsReassign
                            ? _c("BlTextBody2", {
                                attrs: {
                                  text:
                                    "The selected therapist will take over the same appointment slot."
                                }
                              })
                            : _c("BlTextBody2", {
                                attrs: {
                                  text:
                                    "Here's the new timeslot you're rescheduling to:"
                                }
                              })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex flex-col gap-4" }, [
                        _c("div", { staticClass: "flex items-center gap-2" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "w-25 flex-shrink-0 rounded shadow-md"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "h-7 flex items-center justify-center rounded-t bg-prim-100"
                                },
                                [
                                  _c("BlTextBody2", {
                                    staticClass: "text-dark-purple-100",
                                    attrs: { text: "New" }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "h-18 flex flex-col items-center justify-center rounded-b bg-pure-white"
                                },
                                [
                                  _c("BlTextTitle4", {
                                    staticClass: "text-dark-purple-100",
                                    attrs: {
                                      text: _vm.displayDate({
                                        date: _vm.dateInput,
                                        format: "DD"
                                      })
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("BlTextBody2", {
                                    staticClass: "text-light-purple-400",
                                    attrs: {
                                      text: _vm.displayDate({
                                        date: _vm.dateInput,
                                        format: "MMMM"
                                      })
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          !_vm.therapistInput
                            ? _c(
                                "div",
                                { staticClass: "px-2" },
                                [
                                  _c("BlSelectBox", {
                                    staticClass: "w-100",
                                    attrs: {
                                      search: "",
                                      prefixIcon: "user-square",
                                      placeholder: "Select therapist",
                                      options: _vm.therapistOptions,
                                      searching: _vm.therapistLoading
                                    },
                                    on: {
                                      change: _vm.onChangeTherapist,
                                      search: _vm.fetchTherapists
                                    },
                                    model: {
                                      value: _vm.therapistInput,
                                      callback: function($$v) {
                                        _vm.therapistInput = $$v
                                      },
                                      expression: "therapistInput"
                                    }
                                  })
                                ],
                                1
                              )
                            : _c(
                                "div",
                                {
                                  staticClass:
                                    "w-full flex items-center justify-between gap-2"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "w-90 flex flex-col gap-1 px-2"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex items-center gap-2",
                                          attrs: {
                                            title: _vm.therapistInputData.name
                                          }
                                        },
                                        [
                                          _c("BlIcon", {
                                            staticClass: "h-4 w-4",
                                            attrs: {
                                              icon: "user",
                                              color: "slate-6"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("BlTextBody2", {
                                            staticClass: "truncate",
                                            attrs: {
                                              text: _vm.therapistInputData.name
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "flex items-center gap-2"
                                        },
                                        [
                                          _c("BlIcon", {
                                            staticClass: "h-4 w-4",
                                            attrs: {
                                              icon: "clock-outline",
                                              color: "slate-6"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("BlTextBody2", {
                                            attrs: {
                                              text:
                                                _vm.startTimeInput +
                                                " - " +
                                                _vm.endTimeInput
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.enableBranch &&
                                      _vm.room &&
                                      _vm.room.branch
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex items-center gap-2"
                                            },
                                            [
                                              _c("BlIcon", {
                                                staticClass: "h-4 w-4",
                                                attrs: {
                                                  icon: "location",
                                                  color: "slate-6"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("BlTextBody2", {
                                                attrs: {
                                                  text: _vm.room.branch
                                                    ? _vm.room.branch.name
                                                    : "No branch"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "flex items-center gap-2"
                                        },
                                        [
                                          _c("BlIcon", {
                                            staticClass: "h-4 w-4",
                                            attrs: {
                                              icon: "door",
                                              color: "slate-6"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _vm.appointment.room.id ===
                                            _vm.roomInput ||
                                          !_vm.isRescheduleAsReassign
                                            ? _c(
                                                "div",
                                                [
                                                  _c("BlTextBody2", {
                                                    attrs: {
                                                      text: _vm.room.name
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _vm.therapistInputData
                                                    .is_open_room
                                                    ? _c("BlTextBody2", {
                                                        attrs: {
                                                          text: "(open room)"
                                                        }
                                                      })
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            : _c(
                                                "div",
                                                [
                                                  _c("BlTextBody2", {
                                                    staticClass: "font-bold",
                                                    attrs: {
                                                      text:
                                                        "Move to " +
                                                        _vm.room.name
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      !_vm.isRescheduleAsReassign
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex items-center gap-2"
                                            },
                                            [
                                              _c("BlIcon", {
                                                staticClass: "h-4 w-4",
                                                attrs: {
                                                  icon: "piggy",
                                                  color: "slate-6"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                [
                                                  _c("BlTextBody2", {
                                                    attrs: {
                                                      text:
                                                        _vm.newSlotCount +
                                                        " credit(s)"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _vm.serviceData
                                                    ? _c("BlTextBody2", {
                                                        attrs: {
                                                          text:
                                                            "of " +
                                                            _vm.serviceData
                                                              .package_item_name
                                                        }
                                                      })
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.isRescheduleAsReassign
                                    ? _c("BlInputButton", {
                                        attrs: {
                                          type: "outlined",
                                          icon: "edit"
                                        },
                                        on: {
                                          clicked: function($event) {
                                            return _vm.onChangeTherapist(0)
                                          }
                                        }
                                      })
                                    : _c("BlInputButton", {
                                        attrs: {
                                          type: "outlined",
                                          icon: "edit"
                                        },
                                        on: {
                                          clicked: function($event) {
                                            _vm.process = "select_reschedule"
                                          }
                                        }
                                      })
                                ],
                                1
                              )
                        ]),
                        _vm._v(" "),
                        _vm.isRescheduleAsReassign &&
                        _vm.process === "reschedule"
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "py-2 px-3 flex gap-2 bg-cornflower-200 rounded"
                              },
                              [
                                _c("BlIcon", {
                                  staticClass: "h-6 w-6",
                                  attrs: { icon: "info", color: "cornflower-8" }
                                }),
                                _vm._v(" "),
                                _c("BlTextBody2", {
                                  staticClass: "text-cornflower-800",
                                  attrs: {
                                    text:
                                      "No reschedule credits will be required, as the appointment's date and timeslot remain unchanged."
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isRescheduleAsReassign
                          ? _c(
                              "div",
                              { staticClass: "flex items-center gap-2" },
                              [
                                _c("BlTextBody2", {
                                  attrs: {
                                    text: "Need to change the timeslot?"
                                  }
                                }),
                                _vm._v(" "),
                                _c("BlInputButton", {
                                  attrs: {
                                    type: "outlined",
                                    label: "Reschedule appointment",
                                    dense: ""
                                  },
                                  on: {
                                    clicked: function($event) {
                                      _vm.process = "select_reschedule"
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _c(
                              "div",
                              { staticClass: "flex items-center gap-2" },
                              [
                                _c("BlTextBody2", {
                                  attrs: {
                                    text:
                                      "Want to revert to reassigning the therapist?"
                                  }
                                }),
                                _vm._v(" "),
                                _c("BlInputButton", {
                                  attrs: {
                                    type: "outlined",
                                    label: "Reassign to new therapist",
                                    dense: ""
                                  },
                                  on: { clicked: _vm.onBackToReassign }
                                })
                              ],
                              1
                            )
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isOrphanAppointment && _vm.isRescheduleAsReassign
                ? _c(
                    "div",
                    {
                      staticClass:
                        "w-152 py-10 px-10 flex flex-col bg-pure-white rounded-3xl border border-slate-400"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "mb-3 flex flex-col gap-1" },
                        [
                          _c("BlTextSubtitle1", {
                            attrs: {
                              text: "Select credits for this appointment"
                            }
                          }),
                          _vm._v(" "),
                          _c("BlTextBody2", {
                            attrs: {
                              text:
                                "Select the source of credits to apply for this appointment."
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex flex-col gap-4" }, [
                        _c(
                          "div",
                          [
                            _c("BlSelectBox", {
                              key: "select-package-item-" + _vm.therapistInput,
                              attrs: {
                                search: "",
                                prefixIcon: "piggy",
                                placeholder: _vm.creditLoading
                                  ? "Loading ..."
                                  : "Select item",
                                options: _vm.packageItemOptions,
                                disabled: !_vm.therapistInput
                              },
                              on: {
                                change: function($event) {
                                  _vm.packageItemIdInput = $event
                                }
                              },
                              model: {
                                value: _vm.packageItemIdInput,
                                callback: function($$v) {
                                  _vm.packageItemIdInput = $$v
                                },
                                expression: "packageItemIdInput"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "py-2 px-3 flex flex-col gap-2 bg-cornflower-200 rounded"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "flex items-center gap-2" },
                              [
                                _c("BlIcon", {
                                  staticClass: "h-6 w-6",
                                  attrs: {
                                    icon: "piggy",
                                    color: "cornflower-8"
                                  }
                                }),
                                _vm._v(" "),
                                _c("BlTextSubtitle3", {
                                  staticClass: "text-cornflower-800",
                                  attrs: { text: "Credits calculation" }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex flex-col gap-2" },
                              [
                                _c("BlTextBody2", {
                                  staticClass: "text-cornflower-800",
                                  attrs: {
                                    text:
                                      "Credits will be deducted only after the session ends. However, please be aware of the remaining credits available when creating the appointment."
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "flex flex-col gap-1" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex items-center justify-between gap-2"
                                      },
                                      [
                                        _c("BlTextBody2", {
                                          staticClass: "text-cornflower-800",
                                          attrs: {
                                            text:
                                              "Credits used for this appointment(s)"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "rounded h-5.5 w-11 bg-cornflower-800 flex items-center justify-center"
                                          },
                                          [
                                            _c("BlTextSubtitle3", {
                                              staticClass:
                                                "text-cornflower-200",
                                              attrs: { text: _vm.creditsUsed }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex items-center justify-between gap-2"
                                      },
                                      [
                                        _c("BlTextBody2", {
                                          staticClass: "text-cornflower-800",
                                          attrs: {
                                            text:
                                              "Projected remaining credits after this session(s) is completed"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "rounded h-5.5 w-11 bg-cornflower-800 flex items-center justify-center"
                                          },
                                          [
                                            _c("BlTextSubtitle3", {
                                              staticClass:
                                                "text-cornflower-200",
                                              attrs: {
                                                text: _vm.remainingCredits
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.packageItemIdInput && _vm.remainingCredits < 0
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "rounded flex items-start gap-2 py-2 px-3 bg-tulip-100"
                              },
                              [
                                _c("BlIcon", {
                                  staticClass: "h-6 w-6",
                                  attrs: { icon: "warning", color: "tulip-7" }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "flex flex-col w-128" },
                                  [
                                    _c("BlTextBody2", {
                                      staticClass: "text-tulip-700",
                                      attrs: {
                                        text:
                                          "The credits available after this appointment will be negative. Please add credits to the client's account before creating the appointment."
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.appointment.remaining_appointments_count > 0 &&
              _vm.isOrphanAppointment &&
              _vm.isRescheduleAsReassign
                ? _c(
                    "div",
                    {
                      staticClass:
                        "w-152 py-10 px-10 flex flex-col bg-pure-white rounded-3xl border border-slate-400"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "mb-3 flex flex-col gap-1" },
                        [
                          _c("BlTextSubtitle1", {
                            attrs: { text: "Recurring details" }
                          }),
                          _vm._v(" "),
                          _c("BlTextBody2", {
                            attrs: {
                              text:
                                "Specify whether the new therapist will apply to this appointment only or to all remaining appointments."
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex flex-col gap-3" },
                        _vm._l(_vm.reassignOptionOptions, function(opt) {
                          return _c(
                            "div",
                            {
                              key: opt.value,
                              staticClass:
                                "h-10 px-4 flex items-center gap-2 border border-grey-200 rounded"
                            },
                            [
                              _c("BlInputRadio", {
                                attrs: {
                                  name: "reassign_option",
                                  checked: _vm.reassignOptionInput === opt.value
                                },
                                on: {
                                  changed: function($event) {
                                    _vm.reassignOptionInput = opt.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                staticClass: "text-slate-1000",
                                attrs: { text: opt.label }
                              })
                            ],
                            1
                          )
                        }),
                        0
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isOrphanAppointment
                ? _c(
                    "div",
                    {
                      staticClass:
                        "w-152 py-10 px-10 flex flex-col bg-pure-white rounded-3xl border border-slate-400"
                    },
                    [
                      _vm.packageItemInputData
                        ? _c(
                            "div",
                            { staticClass: "mb-3 flex flex-col gap-1" },
                            [
                              _c("BlTextSubtitle1", {
                                attrs: { text: "Reschedule to a new timeslot" }
                              }),
                              _vm._v(" "),
                              _vm.packageItemInputData
                                .total_remaining_reschedule_credit === 0
                                ? _c(
                                    "div",
                                    [
                                      _c("BlTextBody2", {
                                        attrs: {
                                          text:
                                            "This client has no reschedule credits left and cannot change this appointment."
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _c(
                                    "div",
                                    [
                                      _c("BlTextBody2", {
                                        attrs: { text: "This client has" }
                                      }),
                                      _vm._v(" "),
                                      _c("BlTextBody2", {
                                        attrs: {
                                          text:
                                            _vm.packageItemInputData
                                              .total_remaining_reschedule_credit ||
                                            "unlimited"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("BlTextBody2", {
                                        attrs: {
                                          text:
                                            "reschedule credit(s) available."
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("BlTextBody2", {
                                        attrs: {
                                          text:
                                            "Please select a new time slot for this appointment."
                                        }
                                      })
                                    ],
                                    1
                                  )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex flex-col gap-4" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "flex items-center gap-2",
                              class: { "justify-center": !_vm.therapistInput }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "w-25 flex-shrink-0 rounded shadow-md"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "h-7 flex items-center justify-center rounded-t bg-prim-100"
                                    },
                                    [
                                      _c("BlTextBody2", {
                                        staticClass: "text-dark-purple-100",
                                        attrs: { text: "New" }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "h-18 flex flex-col items-center justify-center rounded-b bg-pure-white"
                                    },
                                    [
                                      _c("BlTextTitle4", {
                                        class: [
                                          _vm.dateInput
                                            ? "text-dark-purple-100"
                                            : "text-transparent"
                                        ],
                                        attrs: {
                                          text: _vm.displayDate({
                                            date: _vm.dateInput,
                                            format: "DD"
                                          })
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("BlTextBody2", {
                                        staticClass: "text-light-purple-400",
                                        attrs: {
                                          text: _vm.displayDate({
                                            date: _vm.dateInput,
                                            format: "MMMM",
                                            empty: "Unselected"
                                          })
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.therapistInput
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "w-full flex items-center justify-between gap-2"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "w-90 flex flex-col gap-1 px-2"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex items-center gap-2",
                                              attrs: {
                                                title:
                                                  _vm.therapistInputData.name
                                              }
                                            },
                                            [
                                              _c("BlIcon", {
                                                staticClass: "h-4 w-4",
                                                attrs: {
                                                  icon: "user",
                                                  color: "slate-6"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("BlTextBody2", {
                                                staticClass: "truncate",
                                                attrs: {
                                                  text:
                                                    _vm.therapistInputData.name
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex items-center gap-2"
                                            },
                                            [
                                              _c("BlIcon", {
                                                staticClass: "h-4 w-4",
                                                attrs: {
                                                  icon: "clock-outline",
                                                  color: "slate-6"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("BlTextBody2", {
                                                attrs: {
                                                  text:
                                                    _vm.startTimeInput +
                                                    " - " +
                                                    _vm.endTimeInput
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.enableBranch
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "flex items-center gap-2"
                                                },
                                                [
                                                  _c("BlIcon", {
                                                    staticClass: "h-4 w-4",
                                                    attrs: {
                                                      icon: "location",
                                                      color: "slate-6"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("BlTextBody2", {
                                                    attrs: {
                                                      text: _vm.room.branch
                                                        ? _vm.room.branch.name
                                                        : "No branch"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex items-center gap-2"
                                            },
                                            [
                                              _c("BlIcon", {
                                                staticClass: "h-4 w-4",
                                                attrs: {
                                                  icon: "door",
                                                  color: "slate-6"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _vm.appointment.room.id ===
                                                _vm.roomInput ||
                                              !_vm.isRescheduleAsReassign
                                                ? _c(
                                                    "div",
                                                    [
                                                      _c("BlTextBody2", {
                                                        attrs: {
                                                          text: _vm.room.name
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _vm.therapistInputData
                                                        .is_open_room
                                                        ? _c("BlTextBody2", {
                                                            attrs: {
                                                              text:
                                                                "(open room)"
                                                            }
                                                          })
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "div",
                                                    [
                                                      _c("BlTextBody2", {
                                                        staticClass:
                                                          "font-bold",
                                                        attrs: {
                                                          text:
                                                            "Move to " +
                                                            _vm.room.name
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          !_vm.isRescheduleAsReassign
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "flex items-center gap-2"
                                                },
                                                [
                                                  _c("BlIcon", {
                                                    staticClass: "h-4 w-4",
                                                    attrs: {
                                                      icon: "piggy",
                                                      color: "slate-6"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    [
                                                      _c("BlTextBody2", {
                                                        attrs: {
                                                          text:
                                                            _vm.newSlotCount +
                                                            " credit(s)"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _vm.serviceData
                                                        ? _c("BlTextBody2", {
                                                            attrs: {
                                                              text:
                                                                "of " +
                                                                _vm.serviceData
                                                                  .package_item_name
                                                            }
                                                          })
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("BlInputButton", {
                                        attrs: {
                                          type: "outlined",
                                          icon: "edit"
                                        },
                                        on: {
                                          clicked: function($event) {
                                            _vm.process = "select_reschedule"
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _vm.isRescheduleAsReassign &&
                          _vm.process === "reschedule"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "py-2 px-3 flex gap-2 bg-cornflower-200 rounded"
                                },
                                [
                                  _c("BlIcon", {
                                    staticClass: "h-6 w-6",
                                    attrs: {
                                      icon: "info",
                                      color: "cornflower-8"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("BlTextBody2", {
                                    staticClass: "text-cornflower-800",
                                    attrs: {
                                      text:
                                        "No reschedule credits will be required, as the appointment's date and timeslot remain unchanged."
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.therapistInput
                            ? _c("BlInputButton", {
                                attrs: {
                                  label: "Select timeslot",
                                  dense: "",
                                  disabled:
                                    _vm.packageItemInputData &&
                                    _vm.packageItemInputData
                                      .total_remaining_reschedule_credit === 0
                                },
                                on: {
                                  clicked: function($event) {
                                    _vm.process = "select_reschedule"
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isRescheduleAsReassign
                ? _c(
                    "div",
                    {
                      staticClass:
                        "w-152 py-10 px-10 flex flex-col bg-pure-white rounded-3xl border border-slate-400"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "mb-3 flex flex-col gap-1" },
                        [
                          _c("BlTextSubtitle1", {
                            attrs: { text: "Rescheduling details" }
                          }),
                          _vm._v(" "),
                          _c("BlTextBody2", {
                            attrs: {
                              text:
                                "Please complete the following information to finalize the rescheduling:"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex flex-col gap-4" }, [
                        _c(
                          "div",
                          { staticClass: "flex flex-col gap-1" },
                          [
                            _c("BlTextBody2", {
                              attrs: {
                                text:
                                  "Select who is requesting the rescheduling:"
                              }
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.rescheduleRequesterTypeOptions, function(
                              opt
                            ) {
                              return _c(
                                "div",
                                {
                                  key: opt.value,
                                  staticClass:
                                    "h-10 px-4 flex items-center gap-2 border border-grey-200 rounded"
                                },
                                [
                                  _c("BlInputRadio", {
                                    attrs: {
                                      name: "reschedule_requester_type",
                                      checked:
                                        _vm.rescheduleRequesterTypeInput ===
                                        opt.value
                                    },
                                    on: {
                                      changed: function($event) {
                                        _vm.rescheduleRequesterTypeInput =
                                          opt.value
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("BlTextBody2", {
                                    staticClass: "text-slate-1000",
                                    attrs: { text: opt.label }
                                  })
                                ],
                                1
                              )
                            })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "flex flex-col gap-1" },
                          [
                            _c(
                              "div",
                              [
                                _c("BlTextBody2", {
                                  attrs: {
                                    text:
                                      "Would you like to use 1 rescheduling credits for this appointment change?"
                                  }
                                }),
                                _vm._v(" "),
                                _vm.packageItemInputData &&
                                _vm.packageItemInputData.transaction_used
                                  ? _c(
                                      "span",
                                      [
                                        _c("BlTextBody2", {
                                          attrs: {
                                            text: "(This will be deducted from"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("BlTextBody2", {
                                          staticClass: "font-bold",
                                          attrs: {
                                            text:
                                              "ID " +
                                              _vm.packageItemInputData
                                                .transaction_used
                                                .credit_transaction_id +
                                              ")"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm._l(
                              _vm.subtractRescheduleCreditOptions,
                              function(opt) {
                                return _c(
                                  "div",
                                  {
                                    key: opt.value,
                                    staticClass:
                                      "h-10 px-4 flex items-center gap-2 border border-grey-200 rounded"
                                  },
                                  [
                                    _c("BlInputRadio", {
                                      attrs: {
                                        name: "subtract_reschedule_credit",
                                        checked:
                                          _vm.subtractRescheduleCreditInput ===
                                          opt.value
                                      },
                                      on: {
                                        changed: function($event) {
                                          _vm.subtractRescheduleCreditInput =
                                            opt.value
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("BlTextBody2", {
                                      staticClass: "text-slate-1000",
                                      attrs: { text: opt.label }
                                    })
                                  ],
                                  1
                                )
                              }
                            )
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "flex flex-col gap-1" },
                          [
                            _c("BlSelectBox", {
                              attrs: {
                                label:
                                  "Please select reason for the rescheduling.",
                                asterisk: "",
                                placeholder: "Select rescheduling reason",
                                options: _vm.centerReasonSettings.map(function(
                                  i
                                ) {
                                  return {
                                    value: i.formatted_name,
                                    label: i.name
                                  }
                                }),
                                drop: "up"
                              },
                              on: {
                                change: function($event) {
                                  _vm.rescheduleReasonInput = $event
                                }
                              },
                              model: {
                                value: _vm.rescheduleReasonInput,
                                callback: function($$v) {
                                  _vm.rescheduleReasonInput = $$v
                                },
                                expression: "rescheduleReasonInput"
                              }
                            }),
                            _vm._v(" "),
                            _vm.rescheduleReasonInput === _vm.defaultReason
                              ? _c("BlInputText", {
                                  attrs: {
                                    input: _vm.otherRescheduleReasonInput
                                  },
                                  on: { changed: _vm.inputHandler }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    ]
                  )
                : _vm._e()
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.process === "select_reschedule"
        ? _c("SelectRescheduleTimeslot", {
            attrs: {
              timeslotView: _vm.timeslotView,
              timeslotViewOptions: _vm.timeslotViewOptions
            },
            on: {
              "set-timeslot-view": function($event) {
                _vm.timeslotView = $event
              },
              cancel: function($event) {
                _vm.process = _vm.processStacked.pop()
              },
              continue: _vm.onChangeNewSchedule
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.process !== "select_reschedule"
        ? _c(
            "div",
            {
              staticClass:
                "sticky bottom-0 z-10 h-20 px-6 flex items-center justify-between flex-shrink-0 bg-pure-white border-t border-slate-400"
            },
            [
              _c("BlInputButton", {
                attrs: {
                  type: "error",
                  label: "Cancel appointment",
                  disabled: _vm.submitLoading
                },
                on: {
                  clicked: function($event) {
                    _vm.cancelOpened = true
                  }
                }
              }),
              _vm._v(" "),
              _vm.isRescheduleAsReassign
                ? _c("BlInputButton", {
                    attrs: {
                      label: "Update appointment",
                      disabled: _vm.isDisabledSubmit,
                      loading: _vm.submitLoading
                    },
                    on: { clicked: _vm.onReassign }
                  })
                : _c("BlInputButton", {
                    attrs: {
                      label: "Reschedule appointment",
                      disabled: _vm.isDisabledSubmit,
                      loading: _vm.submitLoading
                    },
                    on: { clicked: _vm.onReschedule }
                  })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.cancelOpened && _vm.currentUser.role.includes("admin")
        ? _c("CancelAppointmentModal", {
            attrs: { appointmentId: _vm.appointment.id },
            on: {
              "close-modal": function($event) {
                _vm.cancelOpened = false
              },
              "after-commit": _vm.onAfterCancelled
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.unavailabilityDetectedOpened
        ? _c(
            "BlBackdrop",
            {
              attrs: {
                title: "Therapist unavailability detected",
                footer: false
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "px-8 mb-4 flex flex-col gap-4",
                  style: { width: "40rem" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex flex-col gap-1" },
                    [
                      _c(
                        "div",
                        [
                          _c("BlTextBody2", {
                            staticClass: "font-bold",
                            attrs: { text: _vm.therapistData.name }
                          }),
                          _vm._v(" "),
                          _c("BlTextBody2", {
                            attrs: {
                              text:
                                "is unavailable on the following dates because they either have conflicting appointments or their availability is in a different room:"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.conflictedDates, function(date, idx) {
                        return _c(
                          "div",
                          {
                            key: idx,
                            staticClass: "flex items-center gap-2 px-2"
                          },
                          [
                            _c("div", {
                              staticClass: "rounded h-1 w-1 bg-slate-800"
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", { attrs: { text: date } })
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c("BlTextBody2", {
                            attrs: {
                              text:
                                "If you proceed, the therapist will only be assigned to"
                            }
                          }),
                          _vm._v(" "),
                          _c("BlTextBody2", {
                            staticClass: "font-bold",
                            attrs: { text: _vm.incomingTotalSuccess }
                          }),
                          _vm._v(" "),
                          _c("BlTextBody2", {
                            attrs: { text: "appointment(s) without conflicts." }
                          })
                        ],
                        1
                      )
                    ],
                    2
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex items-center justify-end px-8 pb-8" },
                [
                  _c(
                    "div",
                    { staticClass: "flex items-center gap-4" },
                    [
                      _c("BlInputButton", {
                        attrs: {
                          type: "outlined",
                          label: "Back to edit appointment"
                        },
                        on: {
                          clicked: function($event) {
                            _vm.unavailabilityDetectedOpened = false
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("BlInputButton", {
                        attrs: { label: "Proceed", loading: _vm.submitLoading },
                        on: { clicked: _vm.onProceedReassign }
                      })
                    ],
                    1
                  )
                ]
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a542ab5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a542ab5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointments/overlay/RescheduleAppointmentOverlay.vue
// module id = null
// module chunks = 